window.$ = window.jQuery = require('jquery');

require('./web_function')

var canModifyHeader = $('meta[name="can_modify_header"]').length;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
$(function () {
    setTimeout(function () {
        $('#rd-loading').fadeOut();
    }, 1000)

    $('#rd-open-menu').on('click', function () {

        $('#rd-menu').toggleClass('active');
        $('#rd-real-menu').toggleClass('vivi');
        $('#rd-top-button-box').toggleClass('hide');
    });

    $('#rd-check-privacy').on('click', function () {
        let url = $('meta[name="check_privacy_url"]').attr('content')
        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            success: function () {

                $('#rd-privacy').fadeOut();
            }
        });
    })

    $('#rd-close-privacy').on('click', function () {
        $('#rd-privacy').fadeOut();
    })

    $('#rd-cancel-change-box').on('click', function () {
        $('#rd-change-box').fadeOut();
    })

    $('#rd-confirm-change-box').on('click', function () {
        window.location.href = $(this).data('url')
    })

    $('.rd-change-identity').on('click', function () {
        let type = $(this).data('type')
        let title = $(this).data('title')

        if (type === 'partner') {
            $('#rd-confirm-change-box').data('url', $('meta[name="partner_url"]').attr('content'))
        } else {
            $('#rd-confirm-change-box').data('url', $('meta[name="patient_url"]').attr('content'))
        }

        $('#rd-change-box').find('#rd-title').html(title)
        $('#rd-change-box').fadeIn();
    })

    if (!canModifyHeader) {

        $(window).resize(function () {

            if ($(this).width() > 768) {
                switchHeaderBlue(true)
            } else {
                switchHeaderBlue(false)
            }
        })

        if ($(this).width() > 768) {
            switchHeaderBlue(true)
        } else {
            switchHeaderBlue(false)
        }
    }

})
